/**
 * 监控平台
 */
export default () => ({
  MONITORINGPLATFORM: {
    component: () => import(
      /* webpackChunkName: 'MonitorCenterPage' */
      'allpages/monitorPlatform/monitorPlatform.vue'
    ),
    // labelName: t('物流区域设置新增')
    labelName: t('监控平台'),
  },
  OVERVIEW: {
    component: () => import(
      /* webpackChunkName: 'MonitorCenterPage' */
      'allpages/monitorPlatform/monitorPlatformOne.vue'
    ),
    // labelName: t('物流区域设置新增')
    labelName: t('概览'),
  },
  PATROL_INSPECTION: {
    component: () => import(
      /* webpackChunkName: 'MonitorCenterPage' */
      'allpages/monitorPlatform/360Scan.vue'
    ),
    labelName: t('巡检'),
  },
  MONITORPLATFORM: {
    component: () => import(
      /* webpackChunkName: 'MonitorCenterPage' */
      'allpages/monitorPlatform/index.vue'
    ),
    labelName: t('监控平台'),
  }
});
